import { render, staticRenderFns } from "./DeclarationCard.vue?vue&type=template&id=7464d4d5&"
import script from "./DeclarationCard.vue?vue&type=script&lang=js&"
export * from "./DeclarationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports